import { render, staticRenderFns } from "./PowerStatistics.vue?vue&type=template&id=3319ac3b&scoped=true&"
import script from "./PowerStatistics.vue?vue&type=script&lang=js&"
export * from "./PowerStatistics.vue?vue&type=script&lang=js&"
import style0 from "./PowerStatistics.vue?vue&type=style&index=0&id=3319ac3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3319ac3b",
  null
  
)

export default component.exports